import { FC } from 'react';
import { UseFieldArrayAppend } from 'react-hook-form';
import { TooltippedSpan } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';
import { Button } from '@optimus-web/core';
import { useBlockSetupContext } from '../../contexts/blockSetupContext';
import { AvailabilityAdjustmentFormValues } from '../../types';
import { DEFAULT_PAX_COUNT } from '../../constants';

interface AddResourceCategoryButtonProps {
    initialValues: AvailabilityAdjustmentFormValues;
    append: UseFieldArrayAppend<AvailabilityAdjustmentFormValues, 'fieldArrayAvailability'>;
}

export const AddResourceCategoryButton: FC<AddResourceCategoryButtonProps> = ({ append, initialValues }) => {
    const { addResourceCategoryDisabled } = useBlockSetupContext();

    const handlePushArrayClick = () =>
        append({
            resourceCategoryId: '',
            paxCount: DEFAULT_PAX_COUNT,
            availabilities: initialValues.fieldArrayAvailability[0].availabilities.map((availability) => ({
                ...availability,
                adjustmentValue: { value: 0 },
            })),
        });

    return (
        <TooltippedSpan
            tooltip={
                !addResourceCategoryDisabled ? null : <LocalizedText textKey={TextKey.AllResourceCategoriesAdded} />
            }
        >
            <Button
                type="button"
                variant="ghost"
                icon={IconName.PlusSimple}
                onClick={handlePushArrayClick}
                data-test-ab-another-resource-category
                disabled={addResourceCategoryDisabled}
            >
                <LocalizedText textKey={TextKey.AnotherResourceCategory} />
            </Button>
        </TooltippedSpan>
    );
};
